var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.143,
    height: 13.572,
    viewBox: "0 0 27.143 13.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "half-battery",
    transform: "translate(27.143) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_empty",
    d: "M13.572,4.519a1.813,1.813,0,0,0-1.805-1.805H9.5V0H4.072V2.714H1.805A1.813,1.813,0,0,0,0,4.519V25.325a1.816,1.816,0,0,0,1.805,1.819h9.948a1.816,1.816,0,0,0,1.819-1.805V4.519Z",
    transform: "translate(0)",
    fill: "rgba(255,165,0,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_filled",
    d: "M0,0V10.4A1.813,1.813,0,0,0,1.805,12.2h9.948A1.816,1.816,0,0,0,13.572,10.4V0Z",
    transform: "translate(0 15.125)",
    fill: "#FFA500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfBattery);
export default __webpack_public_path__ + "static/media/half_battery.89e57d669de5b593d8f2c41390921b3d.svg";
export { ForwardRef as ReactComponent };